
    const data = {"name":"src/core/icons/calendar-check","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 19H5V8h14m0-5h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-2.47 8.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            